<div class="product-container">
  <img [src]="imageSrc" (error)="setDefaultPlaceholder()" class="product-image" alt="product">
  <div class="product-desc-container">
    <div class="product-name"><p>{{ product.name }}</p></div>
<!--    <div class="product-desc"><p>{{ product.description }}</p></div>-->
    <div class="product-price"><p>{{ product.price / 100 }} {{ product.currency }}</p></div>
    <a [routerLink]="['/product', product.slug]">
      <p class="product-details" i18n="@@viewDetails">View details</p>
    </a>
  </div>
</div>
